import DashboardLayout from "./dashboardLayout";

export default DashboardLayout;